import { useAuth } from '../contexts/AuthContext';
import { useCallback } from 'react';
import { fetchWithLog } from '../utils/apiBase';

export function useAuthenticatedFetch() {
  const { token, logout } = useAuth();

  const authenticatedFetch = useCallback(async (url, options = {}) => {
    // Aggiungi il token JWT alle richieste se disponibile
    const headers = {
      ...options.headers,
    };

    // Non impostare Content-Type per FormData (viene gestito automaticamente dal browser)
    if (!options.body || !(options.body instanceof FormData)) {
      headers['Content-Type'] = 'application/json';
    }

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const response = await fetchWithLog(url, {
      ...options,
      headers,
    });

    // Se ricevi 401, il token potrebbe essere scaduto - fai logout automatico
    if (response.status === 401) {
      if (!options.noLogoutOn401) {
        console.warn('⚠️ Token scaduto o non valido, logout automatico');
        logout();
        throw new Error('Sessione scaduta, effettua il login');
      } else {
        // Non fare logout, ma ritorna la response per handling custom
        return response;
      }
    }

    return response;
  }, [token, logout]);

  return authenticatedFetch;
}
